export default __webpack_public_path__ + "static/media/resilience.fe142d07.png";